<template>
  <div>
    <div v-if="$auth.policies['view-period-list']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="route.meta.title"
            :link="[{ text: 'Tài chính', href: '#' }, { text: route.meta.title }]"
          />
        </div>
      </div>
      <v-card outlined class="pa-9 pr-3 mx-4 mb-6 elevation-0">
        <PeriodFilter />
      </v-card>
      <v-card outlined class="mx-4 elevation-0 mb-16">
        <PeriodTable />
      </v-card>
    </div>
    <div v-else>
      <Page403 />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import Page403 from '@/views/Page403.vue'
import { mapActions } from 'vuex'
import PeriodTable from './period-list/PeriodTable.vue'
import PeriodFilter from './period-list/PeriodFilter.vue'

export default {
  components: {
    Breadcrumbs,
    PeriodFilter,
    PeriodTable,
    Page403
  },
  computed: {
    route() {
      return this.$route
    }
  },
  methods: {
    ...mapActions('salaryPeriod', ['fetchPeriods'])
  },
  async created() {
    await this.fetchPeriods()
  }
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
</style>
